import { createContext } from 'react';
import type { ThemeOptions } from '@mui/material/styles';
import type { LabelOptions } from 'labels/types';

export interface LabelContextValue {
  /** Active label name, e.g. `'dokka'`. */
  label: string;
  /** `styles` is the label's MUI theme fragment; the rest becomes `theme.labelOptions`. */
  labelOptions: LabelOptions & { styles: ThemeOptions };
}

// `Labels.js` always wraps the app in a provider, so there is no meaningful default value —
// the empty object stands in rather than forcing the single consumer through a null check.
export const LabelContext = createContext<LabelContextValue>({} as LabelContextValue);

export default LabelContext;
